var isSame = function(local, i, locals) {
    if (i == 0) return true;
    if (locals[i-1].pietro != locals[i].pietro) return true;
    return false;
}
export default isSame;



